import { createContext, useContext, ReactNode } from "react";
import { Company, useAuthenticationSlug } from "../hooks/use-authentication-slug";

type AuthenticationContextType = {
  company: Company | undefined;
  isLoading: boolean;
};

const AuthenticationContext = createContext<AuthenticationContextType | undefined>(undefined);

type AuthenticationProviderProps = {
  children: ReactNode;
};

export const AuthenticationProvider = ({ children }: AuthenticationProviderProps) => {
  const { company, isLoading } = useAuthenticationSlug();

  return (
    <AuthenticationContext.Provider
      value={{
        company,
        isLoading,
      }}
    >
      {children}
    </AuthenticationContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthenticationContext);

  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthenticationProvider");
  }

  return context;
};
